import { render } from "./Stat.vue?vue&type=template&id=903437d0&scoped=true"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903437d0"]])

export default __exports__